query UserTemplate($id: UUID!) {
  departmentOccupationTemplate(id: $id) {
     id
     __typename
     _rowTimestamp
      name
      description
      _isSyncAllowed
      roleId
      role {
        id
        name
      }
      userOccupationTitleId
      userOccupationTitle {
        id
        userOccupationTitle
      }
      departmentId
      department {
        id
        name
      }
      departmentGroupId
      departmentGroup {
        id
        name
      }
      dataAccessPolicyId
      dataAccessPolicy {
        id
        name
      }
      userGroupId
      userGroup {
        id
        name
      }
      accessGroupId
      accessGroup {
        id
        name
      }
      tagGroupId
      tagGroup {
        id
        name
      }
      communicationGroupId
      communicationGroup {
        id
        name
      }
      userRankTypeId
      userRank {
        id
        userRank
      }
      secureRowLevelId
      secureRowLevel {
        id
        name
      }
      userDefaultCompany
      userDefaultLocation
      isUserPrimaryCurrencyDefault
      isUserDepartmentDefault
      isUserPrimaryBusinessUnitDefault
      isTemplateControlled
      isDepartmentUserGroupRequired
      _isUpdatable
      _isDeletable
       departmentOccupationTemplatesHistoriesByEntityId
    {
      nodes{
        tenantUserName
        pointInTimeDate
        crudOperation
      }
    }
      departmentOccupationApprovals(
        orderBy: APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC
      ) {
        nodes {
          id
          _rowTimestamp
          approvalTypeId
          isRequester
          isApprover
          isSelfApproveEnabled
          isLowerTreeLevelBypassEnabled
          isEnMasseApprovalsEnabled
          isAutoApproveEnabled
          isApprovalTreeViewerAllowed
          isApprovalRevokingEnabled
          isAddingNonApproversAllowed
          isExtendedApprover
        }
      }
      departmentOccupationCharts(orderBy: CHART_TYPE_BY_CHART_TYPE_ID__CAPTION_ASC) {
        nodes {
          id
          _rowTimestamp
          chartTypeId
          chartType {
            caption
          }
          isActive
          chartPosition
        }
      }
    }

  }
